import{a as e,d as n}from"./chunk-QYQWCYOC.js";import{a as c}from"./chunk-IT2KRYHF.js";import{e as t}from"./chunk-7QKJRE4B.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();n();function u(r){e.dispatch(t(r))}export{u as a};
//# sourceMappingURL=chunk-Y2QQ5I2M.js.map
